/**
 *   Wyświetla okno modalne do ćwiczeń - blokuje jeśli błędy
 */

import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import Exercises from './Exercises';


function Exercise (props) {
  const params = useParams();
  const { sections } = props;
  const { unit } = params;

  const currentSection = sections.find(sect => sect.slug === unit);
  let currentPart = false;
  if (currentSection && currentSection.parts.length > 0 )
    currentPart = currentSection.parts.find(par => par.slug === params.exercise);
  if (!currentPart || !currentSection || currentSection.parts.length === 0) return ''; // Todo - tu powinno być wyświetlona strona 404

  return (
    <Exercises currentSection={currentSection} />
  );
}

const mapStateToProps = (state) => {
  return {
    sections: state.courseSections,
  }
}

export default connect(mapStateToProps)(Exercise);
